import React from 'react';
import theme from '../../theme';

// Chrome-like tabs: the active tab's border flows into the frame around the content.
export default function FolderTabs({ tabs, active, onChange, children }) {
  const first = tabs[0]?.key === active;
  return (
    <div>
      <div className="flex items-end gap-1" role="tablist">
        {tabs.map(({ key, label }) => {
          const on = key === active;
          return (
            <button
              key={key}
              type="button"
              role="tab"
              aria-selected={on}
              onClick={() => onChange(key)}
              className={`relative -mb-px rounded-t-xl border px-4 py-2 text-sm font-semibold transition-colors ${on
                ? `z-10 ${theme.cardBg} border-olive-200 border-b-white text-olive-700`
                : 'border-transparent text-gray-500 hover:bg-olive-50 hover:text-olive-600'}`}
            >
              {label}
            </button>
          );
        })}
      </div>
      <div className={`${theme.cardBg} ${theme.cardBorder} rounded-2xl ${first ? 'rounded-tl-none' : ''} overflow-hidden`}>
        {children}
      </div>
    </div>
  );
}
